import React from 'react';

const GanttChartIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6.75h10.5M4 12h14M4 17.25h7.5" />
    </svg>
);

export default GanttChartIcon;
